<template>
    <section class="overflow-auto scroll-none pt-1" style="height:calc(100vh - 75px)">
        <div class="px-4  px-lg-5" style="min-height:90vh">
            <div class="row mx-0 mb-3">
                <div class="col-auto">
                    <p class="f-30 text-general f-500">
                        Ofertas especiales
                    </p>
                    <div class="like-bar" />
                </div>
            </div>
            <div class="row mx-0 my-3">
                <div class="col-auto">
                    <img :src="promocion.imagen ? promocion.imagen :'/img/no-imagenes/promociones.png'" width="440" height="160px" class="img-promo br-12 border" />
                </div>
                <div class="col-12 col-lg-5 mt-4 mt-lg-0">
                    <div class="mb-2">
                        <p class="f-30 text-general f-500 ucfirst"> {{ promocion.nombre }} </p>
                        <div class="like-bar" />
                    </div>
                    <p class="text-general f-13 f-500"> {{ promocion.descripcion }} </p>
                    <div>
                        <i v-show="promocion.tipo != 6" class="text-general2 f-13 f-500">
                            Vigencia: Del {{ promocion.inicio | helper-fecha('DD MMMM YYYY') }} al {{ promocion.fin | helper-fecha('DD MMMM YYYY') }}
                        </i>
                    </div>
                </div>
            </div>
            <cargando v-if="cargando" />
            <div class="row mx-0 py-2 mt-5">
                <invitado-producto v-for="(producto,index) in productos" :key="index" :producto="producto" class="mx-4 mb-2" />
            </div>
        </div>
    </section>
</template>

<script>
import Service from '~/services/invitado/invitado'
import { mapGetters } from 'vuex'
export default {
    data(){
        return {
            promocion: {},
            productos: [],
            cargando:false
        }
    },
    computed: {
        ...mapGetters({
            tienda: 'invitado/tienda',
        }),
        idPromocion(){
            return this.$route.params.idPromocion
        },
        idTienda(){
            return this.tienda.id_tienda
        },
    },
    mounted(){
        this.getPromocion();
    },
    methods: {
        async getPromocion(){
            try {
                if(!this.tienda.id_tienda){
                    await this.$store.dispatch('invitado/getTiendaDefault')
                }
                const params = {
                    idTienda:this.idTienda
                }
                const { data } = await Service.getPromocion(this.idPromocion,params);
                this.promocion = data.promocion;
                this.getProductosPromocion();
            } catch(e){
                this.errorCatch(e)
            }
        },
        async getProductosPromocion(){
            try {
                this.cargando = true
                const params = {
                    idTienda: this.idTienda
                };
                const { data } = await Service.getProductosPromocion(this.idPromocion, params);
                this.productos = data.productos;
            } catch(e){
                this.errorCatch(e)
            } finally{
                this.cargando = false
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.img-promo{
	width: 100%;
	height: auto;
	max-height: 160px;
}
</style>